angular
  .module('admin')

  .factory('PMCache', function() {
    let cache;

    return {
      get: () => cache,
      set: value => (cache = value)
    };
  });
